import Request, { SimpleResponse } from './Request';
import { IUser } from './User';

export interface IActual {
    id: number;
    groupId: number;
    groupName: string;
    groupCode: string;
    groupParentId: number;

    status: IStatus;

    channels: IChannel[];
    children: IActual[];
}

export interface IChannel {
    channelId: number;
    channelName: string;
    channelOrder: number;
    
    channelTypeId: number;
    channelTypeName: string;
    channelTypeSlug: string;

    id: number;
    actual: number;
}

export interface IStatus {
    id: number;
    name: string;
    slug: string;
    order: string;
}

export interface IMessage {
    id: number;
    actualId: number;
    message: string;
    creationDate: Date;
    user: IUser;
}

class Actual {
    static GetAllStatus = (): IStatus[] => { return Request.DoGet('actual/status') as unknown as IStatus[]; };
    static SetStatus = (id: Number, data: IStatus): SimpleResponse => { return Request.DoPut('actual/status/' + id, data) as unknown as SimpleResponse; };
    static GetMessages = (tradesaleId: Number): IMessage[] => { return Request.DoGet('actual/messages/' + tradesaleId) as unknown as IMessage[]; };
    static CreateMessage = (data: IMessage): SimpleResponse => { return Request.DoPost('actual/messages', data) as unknown as SimpleResponse; };
    static GetAll = (year: Number, month: Number): IActual[] => { return Request.DoGet('actual/all/' + year + '/' + month) as unknown as IActual[]; };
    static Get = (group: Number, year: Number, month: Number): IActual => { return Request.DoGet('actual/' + group + '/' + year + '/' + month) as unknown as IActual; };
    static Update = (id: Number, data: IActual): SimpleResponse => { return Request.DoPut('actual/' + id, data) as unknown as SimpleResponse; };
    static Create = (year: Number, month: Number, data: IActual): SimpleResponse => { return Request.DoPost('actual/' + year + '/' + month, data) as unknown as SimpleResponse; };
}

export default Actual;